export enum WorkflowPromptSubmissionStatusRaw {
  failure = 'FAILURE',
  inProgress = 'IN_PROGRESS',
  success = 'SUCCESS'
}
